import { useEffect } from "react";

import { graphql, useFragment } from "react-relay";

import { useAlertContext } from "app/contexts";

import type { useProblemsAlert_problems$key } from "./__generated__/useProblemsAlert_problems.graphql";

export function useProblemsAlert(
  queryRef: useProblemsAlert_problems$key | undefined | null,
) {
  const data = useFragment(
    graphql`
      fragment useProblemsAlert_problems on Problems {
        problems {
          message
        }
      }
    `,
    queryRef,
  );
  const { alertDispatch } = useAlertContext();

  useEffect(() => {
    if (data && data.problems?.length > 0) {
      alertDispatch({
        message: data.problems.map((problem) => problem.message),
        severity: "error",
        duration: 10000,
      });
    }
  }, [alertDispatch, data]);

  return data && (data.problems?.length ?? 0) > 0;
}
